import Phaser from 'phaser';

import { BoardViewModel } from './board-view-model';
import { BlocksMainScene } from '../../scenes/blocks-main-scene';
import { Subscription } from 'rxjs';
import { StartView } from './start-view';
import { GameSizeMetrics } from 'src/games/common/phaser/game/scenes/scaled-base-scene';
import { GridView } from '../grid/grid-view';
import { ShapeBoardView } from '../shape/shape-board-view';
import { LevelView } from './level-view';
import { LoadingGridView } from '../loading/loading-grid-view';
import { MultiplierControlView } from './multiplier-control-view';
import { LevelControlView } from './level-control-view';

export class BoardView extends Phaser.GameObjects.Container {
  private subscriptionGroup: Subscription;

  private loadingGridView: LoadingGridView;
  private gridView: GridView;
  private shapeBoardView: ShapeBoardView;
  private multiplierControlView: MultiplierControlView;
  private levelControlView: LevelControlView;
  private levelView: LevelView;
  private startView: StartView;

  constructor(scene: BlocksMainScene, x: number, y: number, viewModel: BoardViewModel) {
    super(scene, x, y);

    this.subscriptionGroup = new Subscription();

    this.loadingGridView = new LoadingGridView(scene, 0, 0, viewModel.loadingGridViewModel);
    this.add(this.loadingGridView);

    this.gridView = new GridView(scene, 0, 0, viewModel.gridViewModel);
    this.add(this.gridView);

    this.shapeBoardView = new ShapeBoardView(scene, 0, 0, viewModel.shapeBoardViewModel);
    this.add(this.shapeBoardView);

    this.multiplierControlView = new MultiplierControlView(
      scene,
      0,
      0,
      viewModel.multiplierControlViewModel,
    );
    this.add(this.multiplierControlView);

    this.levelControlView = new LevelControlView(scene, 0, 0, viewModel.levelControlViewModel);
    this.add(this.levelControlView);

    this.levelView = new LevelView(scene, 0, 0, viewModel.levelViewModel);
    this.add(this.levelView);

    this.startView = new StartView(scene, 0, 0, viewModel.startViewModel);
    this.add(this.startView);

    this.setName(BoardView.name);
    scene.add.existing(this);

    scene.events.on(
      Phaser.Scenes.Events.UPDATE,
      (time: number, delta: number) => this.sceneUpdate(time, delta),
      this,
    );

    this.subscriptionGroup.add(
      viewModel.shapeBoardViewModel.onShapeDragAction$.subscribe((dragData) => {
        this.gridView.handleShapeDrag(dragData);
      }),
    );
  }

  public onResize(gameSizeMetrics: GameSizeMetrics) {
    this.loadingGridView?.onResize(gameSizeMetrics);
    this.gridView?.onResize(gameSizeMetrics);
    this.shapeBoardView?.onResize(gameSizeMetrics);
    this.multiplierControlView?.onResize(gameSizeMetrics);
    this.levelControlView?.onResize(gameSizeMetrics);
    this.levelView?.onResize(gameSizeMetrics);
    this.startView?.onResize(gameSizeMetrics);
  }

  override destroy(_fromScene?: boolean | undefined): void {
    this.subscriptionGroup.unsubscribe();

    super.destroy(_fromScene);
  }

  private sceneUpdate(time: number, delta: number) {
    this.shapeBoardView?.sceneUpdate(time, delta);
  }
}
